var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"common-employee-details-modal","title":_vm.title,"title-class":"h4 font-weight-bold","lazy":"","size":"xl","hide-footer":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }